let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("byj2y")).then(() => parcelRequire('2OsED'));